import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";

import { Partner } from "@customTypes/partner";

export const useUpdatePartnerProfile = (partnerId: string) => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: async (formData: FormData) => {
      const { data } = await api.patch<Partner>(`partners/${partnerId}/profile`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    },
    onSuccess: () => {
      notifications.show({
        title: "Success",
        message: "Partner profile updated successfully",
        color: "green",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.partners(),
      });
    },
    onError: (res: any) => {
      console.error("[From Update Partner Profile Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};
